export const PLACE_NORMALTRADE_DATA = "PLACE_NORMALTRADE_DATA";
export const PLACE_NORMALTRADE_ERROR_DATA = "PLACE_NORMALTRADE_ERROR_DATA";
export const PLACE_NORMALTRADE_HIDE_ERROR_DATA = "PLACE_NORMALTRADE_HIDE_ERROR_DATA";
export const PLACE_NORMALTRADE_CLEAR_DATA = "PLACE_NORMALTRADE_CLEAR_DATA";
export const PLACE_NORMALTRADE_START_LOADER = "PLACE_NORMALTRADE_START_LOADER";
export const PLACE_NORMALTRADE_STOP_LOADER = "PLACE_NORMALTRADE_STOP_LOADER";
